<template>
    <div
        @dragenter.stop="is_drag_enter = true"
        @dragleave.stop="is_drag_enter = false"
        @dragover.stop="$event.preventDefault()"
        @drop.prevent.stop="drop">

        <div class="dropdown"
            :class="{'is-active': show_dropdown}"
            @mouseleave="show_dropdown = false">

            <a @click="$emit('select', topic.id)"
               :class="{'is-active': active}"
               class="topic menu-item">

                <i v-if="topic.is_general" class="top-icon">#</i>
                <i v-else-if="topic.bookmarked" class="fas fa-thumbtack top-icon"></i>
                <i v-if="topic.is_private" class="fas fa-shield-alt top-icon"></i>
                <i class="icon fas fa-copy"></i>

                {{topic.name}}

                <i v-if="space_permission('TOPIC_UPDATE') || space_permission('TOPIC_DELETE')"
                   class="icon fas fa-ellipsis-v is-pulled-right" @click.stop="dropdown"></i>
            </a>

            <div class="dropdown-menu">
                <div class="dropdown-content">
                    <a @click="bookmark_topic" class="dropdown-item">
                        <i class="icon fas fa-thumbtack"></i>
                        {{ topic.bookmarked ? 'Unpin' : 'Pin' }} topic
                    </a>

                    <a v-if="space_permission('TOPIC_UPDATE')"
                       @click="$emit('edit')"
                       class="dropdown-item">
                        <i class="icon fas fa-pen"></i>Edit
                    </a>

                    <a v-if="space_permission('TOPIC_UPDATE') && !topic.is_general && !topic.is_private"
                        @click="make_general"
                        class="dropdown-item">
                        <i class="icon fas fa-flag"></i>Set as default
                    </a>

                    <a v-if="space_permission('TOPIC_DELETE') && !topic.is_general"
                       @click="remove"
                       class="dropdown-item">
                        <i class="icon fas fa-trash-alt"></i>Delete
                    </a>
                </div>
            </div>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove this Topic?"
            @close="show_confirm = false"
            @ok="remove_topic"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { copy } from '../../utils/helpers';

export default {
    name: 'TopicsItem',
    props: ['space', 'topic'],
    data() {
        return {
            show_confirm: false,
            show_dropdown: false,
            is_drag_enter: false,
        };
    },
    computed: {
        ...mapState('tree', ['moving_element']),
        active() {
            return parseInt(this.$route.query.topic, 10) === this.topic.id || this.is_drag_enter;
        },
    },
    methods: {
        dropdown() {
            this.show_dropdown = !this.show_dropdown;
        },
        async bookmark_topic() {
            await this.$store.dispatch('topics/bookmark', {
                space_id: this.space.id,
                topic_id: this.topic.id,
                remove: this.topic.bookmarked,
            });

            this.$store.dispatch('topics/list', { space_id: this.space.id });

            this.show_dropdown = false;
        },
        remove() {
            this.show_dropdown = false;
            this.$store.dispatch('topics/detail', {
                space_id: this.space.id,
                topic_id: this.topic.id,
            }).then((result) => {
                if (result.notes_count > 0) {
                    // eslint-disable-next-line no-alert
                    alert(`This topic contains ${result.notes_count} note(s). `
                            + 'Please move them to other topics first.');
                    return;
                }

                this.show_confirm = true;
            });
        },
        async remove_topic() {
            await this.$store.dispatch('topics/remove', {
                parent_id: this.parent_id,
                space_id: this.space.id,
                topic_id: this.topic.id,
            });

            const { topic } = this.$route.query;
            if (topic && this.topic.id === topic) {
                this.$router.push({ name: 'content', params: this.$route.params });
            }
        },
        drop() {
            this.is_drag_enter = false;
            const element = copy(this.moving_element);

            if (element.kind === 'note') {
                this.move_note(element);
            } else if (element.kind === 'collection') {
                this.move_collection(element);
            }
        },
        async move_note(element) {
            const topic_id = parseInt(this.$route.query.topic, 10);

            if (!topic_id || this.topic.id !== topic_id) {
                await this.$store.dispatch('notes/update', {
                    space_id: this.space.id,
                    note_id: element.id,
                    data: { topic: this.topic.id, collection: null, is_private: false },
                    patch: true,
                });

                // was dropped from notes list
                if (element.source === 'notes_list') {
                    this.$store.commit('notes/change_note_topic', {
                        note_id: element.id,
                        topic: this.topic,
                    });
                } else if (element.source === 'tree') {
                    this.$store.commit('tree/remove_item', element);
                }

                this.$store.commit('tree/remove_open_note', element.id);
            }
        },
        async move_collection(element) {
            await this.$store.dispatch('tree/update_collection', {
                space_id: this.space.id,
                collection_id: element.id,
                data: { topic: this.topic.id, parent: null, is_private: false },
            });
            this.$store.commit('tree/remove_item', element);
        },
        async make_general() {
            await this.$store.dispatch('topics/make_general', {
                space_id: this.space.id,
                topic_id: this.topic.id,
            });
            this.$store.commit('topics/make_general', this.topic.id);
        },
    },
};
</script>

<style scoped>
    .topic .fa-ellipsis-v {
        display: none;
        position: absolute;
        right: 0;
    }

    .topic:hover .fa-ellipsis-v {
        display: -ms-inline-flexbox;
        display: inline-flex;
    }
</style>
